/* SilkPearl journal — article contents rail and share actions */
(function () {
  'use strict';

  var root = document.querySelector('[data-sp-article]');
  if (!root) return;

  /* ---------- contents ----------
     Article bodies are free HTML written in the Shopify editor, so the
     headings are only knowable once rendered. Build the list from the DOM
     and leave the rail hidden when there is nothing worth listing. */
  var body = root.querySelector('[data-sp-article-body]');
  var toc = root.querySelector('[data-sp-toc]');
  var list = root.querySelector('[data-sp-toc-list]');

  function slugify(text, index) {
    var base = String(text).toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    return base ? base.slice(0, 60) : 'section-' + index;
  }

  if (body && toc && list) {
    var headings = [].slice.call(body.querySelectorAll('h2'));
    if (headings.length >= 2) {
      var used = {};
      headings.forEach(function (h, i) {
        var id = h.id;
        if (!id) {
          id = slugify(h.textContent, i);
          /* duplicate headings would break the anchors */
          if (used[id]) { id = id + '-' + i; }
          h.id = id;
        }
        used[id] = true;

        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + id;
        a.textContent = h.textContent.trim();
        a.className = 'sp-art__toc-link';
        li.appendChild(a);
        list.appendChild(li);
      });
      toc.hidden = false;

      /* mark the section currently in view */
      if ('IntersectionObserver' in window) {
        var links = {};
        [].slice.call(list.querySelectorAll('a')).forEach(function (a) {
          links[a.getAttribute('href').slice(1)] = a;
        });
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var a = links[e.target.id];
            if (a) a.classList.toggle('is-current', e.isIntersecting);
          });
        }, { rootMargin: '-10% 0px -70% 0px' });
        headings.forEach(function (h) { io.observe(h); });
      }
    }
  }

  /* ---------- copy link ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sp-copy]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('data-sp-copy');
    var done = function () {
      btn.classList.add('is-done');
      window.setTimeout(function () { btn.classList.remove('is-done'); }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(function () {});
      return;
    }
    /* older Safari has no clipboard API on non-secure origins */
    var f = document.createElement('input');
    f.value = url;
    document.body.appendChild(f);
    f.select();
    try { document.execCommand('copy'); done(); } catch (err) {}
    document.body.removeChild(f);
  });
})();
